import script from "./attached-documents-history.vue?vue&type=script&setup=true&lang=js"
export * from "./attached-documents-history.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__